<template>
  <div class="order-detail">
    <div class="panel">
      <div class="top-box">
        <div class="title">订单详情</div>
        <el-button class="fixed-back-btn" @click="back">返回</el-button>
      </div>
      <div class="order-info">
        
        <div class="info-box">
          <img class="status-img" v-if="detail.orderStatus == 1" src="@static/images/order/orderD2.png" />
          <img class="status-img" v-if="detail.orderStatus == 2 || detail.orderStatus == 9" src="@static/images/order/orderD1.png" />
          <img class="status-img" v-if="detail.orderStatus == 3" src="@static/images/order/orderD5.png" />
          <img class="status-img" v-if="detail.orderStatus == 4" src="@static/images/order/orderD4.png" />
          <img class="status-img" v-if="detail.orderStatus == 5 || detail.orderStatus == 6" src="@static/images/order/orderD3.png" />
          <div class="order-status">
            <div class="text1" :class="{ blue: [2, 9].indexOf(detail.orderStatus * 1) != -1, gray: [3, 4, 5, 6].indexOf(detail.orderStatus * 1) != -1 }">
              {{ all.ORDER_STATUS[detail.orderStatus] }}
            </div>
            <div class="text2" v-if="detail.orderStatus == 1">距离过期还剩{{ detail.expireTimeFormatStr }}</div>
            <div class="text2" v-if="detail.orderStatus == 4">失败原因：{{ detail.message }}</div>
          </div>
        </div>
        <el-steps :active="step" align-center v-if="detail.unFinishedOrderAuthorized != 'false'">
          <el-step title="待跟进"></el-step>
          <el-step title="跟进中"></el-step>
          <el-step title="跟进完成"></el-step>
        </el-steps>
      </div>
      <el-collapse class="collapse" v-model="activeNames" :disabled="true">
        <el-collapse-item title="基本信息" name="1" :disabled="true">
          <div class="box">
            <div class="item">
              <div class="label">产品名称</div>
              <div class="label">{{ detail.productName }}</div>
            </div>
            <div class="item">
              <div class="label">投保时间</div>
              <div class="label">{{ detail.orderTime | timeSubstr(0, 16) }}</div>
            </div>
            <div class="item">
              <div class="label">订单号</div>
              <div class="label">{{ detail.orderId }}</div>
            </div>
            <div class="item">
              <div class="label">保障额度</div>
              <div class="label">{{ detail | policyLimit }}</div>
            </div>
            <div class="item">
              <div class="label">保障期限</div>
              <div class="label">{{ detail.guarantee }}</div>
            </div>
            <div class="item">
              <div class="label">交费方式</div>
              <div class="label">{{ all.PAY_TYPE[detail.payType] }}</div>
            </div>
            <div class="item">
              <div class="label">交费期限</div>
              <div class="label" v-if="detail.payment == 4 || detail.payment == 5">{{ all.PAYMENT_TYPE[detail.payment] }}</div>
              <div class="label" v-else>{{ detail.payPerm }}{{ all.PAYMENT_TYPE[detail.payment] }}</div>
            </div>
            <div class="item">
              <div class="label">保费</div>
              <div class="label">{{ detail.fee }}</div>
            </div>
            <div class="item">
              <div class="label">起保日期</div>
              <div class="label">{{ detail.startTime | timeSubstr(0, 10) }}</div>
            </div>
            <div class="item">
              <div class="label">终保日期</div>
              <div class="label">{{ detail.endTime | timeSubstr(0, 10) }}</div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="投保人信息" name="2" :disabled="true">
          <div class="box">
            <div class="item">
              <div class="label">投保人</div>
              <div class="label">{{ detail.policyerName }}</div>
            </div>
            <div class="item">
              <div class="label">手机号码</div>
              <div class="label">{{ detail.policyerMobile }}</div>
            </div>
            <div class="item">
              <div class="label">证件类型</div>
              <div class="label">{{ detail.policyerCardTypeDesc }}</div>
            </div>
            <div class="item">
              <div class="label">证件号码</div>
              <div class="label">{{ detail.policyerIdCard }}</div>
            </div>
            <div class="item" v-if="detail.holderAreaStr">
              <div class="label">所在地区</div>
              <div class="label">{{ detail.holderAreaStr }}</div>
            </div>
            <div class="item" v-if="detail.holderHomeAddress && detail.holderHomeAddress.indexOf('[') != 0">
              <div class="label">详细地址</div>
              <div class="label">{{ detail.holderHomeAddress }}</div>
            </div>
            <div class="item" v-if="detail.holderEmail">
              <div class="label">电子邮箱</div>
              <div class="label">{{ detail.holderEmail }}</div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="被保险人信息" name="3" :disabled="true">
          <div class="border-box" v-for="(bean, i) in insuredersJson" :key="i">
            <div class="box-title" v-if="insuredersJson.length == 1">被保险人信息</div>
            <div class="box-title" v-else>被保险人信息{{ i + 1 }}</div>
            <div class="box">
              <div class="item">
                <div class="label">姓名</div>
                <div class="label">{{ bean.insurederName }}</div>
              </div>
              <div class="item">
                <div class="label" style="min-width: 115px">与投保人关系</div>
                <div class="label">{{ bean.insuredRelationship | beneRelationship }}</div>
              </div>
              <div class="item">
                <div class="label">证件类型</div>
                <div class="label">{{ all.CARD_TYPE[bean.insurederCardType] }}</div>
              </div>
              <div class="item">
                <div class="label">证件号码</div>
                <div class="label">{{ bean.insurederIdCard }}</div>
              </div>
            </div>
            <div class="inside-table">
              <ul class="tr head">
                <li>保障权益</li>
                <li>保障额度/详情</li>
              </ul>
              <ul class="tr" v-for="(item, i) in garmtee" :key="i" v-if="!item.insurederIdCard || item.insurederIdCard == bean.insurederIdCard">
                <li>{{ item.premiseAttribute }}</li>
                <li>{{ item.guaranteeMoney }}</li>
              </ul>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="受益人信息" name="4" :disabled="true">
          <div class="box">
            <div class="item">
              <div class="label" style="min-width: 125px">受益人类型</div>
              <div class="label" v-if="detail.beneficiaryType == 1">法定受益人</div>
              <div class="label" v-else-if="detail.beneficiaryType == 2">指定受益人</div>
              <div class="label" v-else-if="detail.beneficiaryType == 3">被保险人</div>
            </div>
          </div>
          <el-table :data="beneInfo" style="width: 100%" border v-if="beneInfo.length">
            <el-table-column prop="beneName" label="姓名"></el-table-column>
            <el-table-column prop="beneIdCard" label="证件号码"></el-table-column>
            <el-table-column prop="beneRelationship" label="与被保险人关系">
              <template slot-scope="scope">
                {{ scope.row.beneRelationship | beneRelationship }}
              </template>
            </el-table-column>
            <el-table-column prop="beneRate" label="收益比例">
              <template slot-scope="scope"> {{ scope.row.beneRate }}% </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="bottom-box">
      <el-button plain @click="getServiceList" size="small" type="warning" v-if="detail.unFinishedOrderAuthorized != 'false'">服务日志</el-button>
      <el-button plain @click="openProduct" size="small" type="warning" v-if="checkAuth('productList')">产品详情</el-button>
      <el-button size="small" type="warning" id="copy" @click="copyLink" v-if="detail.orderStatus == 1">复制订单链接</el-button>
    </div>
    <el-dialog :visible.sync="detailVisible" width="900px" title="服务日志">
      <div class="content">
        <el-table class="omtable" ref="singleTable" border :stripe="true" :data="serviceList" style="width: 100%">
          <el-table-column property="updateTime" min-width="250px;" label="服务时间"></el-table-column>
          <el-table-column property="chatTypeDesc" label="沟通方式" min-width="100px;"></el-table-column>
          <el-table-column property="content" label="服务内容" min-width="380px;"></el-table-column>
        </el-table>
        <el-pagination
          class="page"
          :current-page.sync="serviceCurrent"
          background
          layout="total,prev, pager, next"
          :page-size="10"
          @current-change="serviceCurrentChange"
          :total="serviceTotal"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
import { common } from "@/api/mixins";
//当前实例组件
export default {
  mixins: [common],
  data: () => ({
    detailVisible: false,//服务日志弹窗
    serviceCurrent: 1,//服务日志当前页数
    serviceTotal: 0,//服务日志记录数
    serviceList: [],
    step: 0,
    all: {},
    detail: {},
    beneInfo: [],//受益人信息
    garmtee: [],//保障权益
    insuredersJson: [],//被保人信息
    activeNames: ["1", "2", "3", "4"],
  }),
  created() {
    this.$tools.getall(data => {
      this.all = data;
    });
    this.getData();
  },
  methods: {
    // 服务日志翻页
    serviceCurrentChange(page) {
      this.serviceCurrent = page;
      this.getServiceList();
    },
    // 获取服务日志列表
    getServiceList() {
      const params = {
        orderId: this.detail.orderId,
        pageNum: this.serviceCurrent,
        pageSize: 10,
      }
      this.$http({
        url: '/master/order/unfinishedOrderRecord',
        type: 'put',
        params: params,
      }).then((res) => {
        this.serviceList = res.data;
        this.serviceTotal = res.total;
        this.detailVisible = true;
      })
    },
    getData() {
      this.$http({
        url: '/master/order/unfiniedOrderDetail',
        type: 'get',
        params: {
          orderId: this.$route.query.orderId
        },
      }).then((res) => {
        this.detail = res.data;
        this.insuredersJson = res.data.insuredersJson;
        if (res.data.garmtee) {
          this.garmtee = JSON.parse(res.data.garmtee);
        }
        if (this.detail.beneInfo) {
          this.beneInfo = JSON.parse(this.detail.beneInfo);
        }
        if (this.detail.followStatus) {
          this.step = this.detail.followStatus - 1;
        }
      })
    },
    copyLink() {
      var clipboard = new Clipboard("#copy", {
        text: () => {
          return this.$config.api_root + "/yunying/bdgj/index.html#/personal/orderDetail/" + this.$route.query.orderId;
        },
      });
      clipboard.on('success', (e) => {
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        clipboard.destroy();
      });
    },
    // 产品详情
    openProduct() {
      window.open(this.detail.productUrl);
    },
    back() {
      history.go(-1);
    }

  },
};
</script>
<style lang="scss">
@import './order_detail';
</style>
